export const FETCH_ALLVEHICLE_REQUEST = 'FETCH_ALLVEHICLE_REQUEST'
export const FETCH_ALLVEHICLE_SUCCESS = 'FETCH_ALLVEHICLE_SUCCESS'
export const FETCH_ALLVEHICLE_FALIURE = 'FETCH_ALLVEHICLE_FALIURE'
